// This address points to a dummy ERC-20 contract. Replace it with your own smart contracts.
const addresses = {
  DocAddress: "0xa6a11dF4FAc5c4b148bC91f03FD0919237d16801",
};
export default addresses;

//kovan = 0x6DdD958591974891eD4819cDF9a269DaEc3C55A7